/* src/app/order/components/billing-information/dekra-billing-data/dekra-billing-data.style.scss */
.billing-info {
  display: flex;
  flex-direction: column;
}
.billing-info .dekra-label {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  color: #007d40;
  margin: 0;
  padding: 0 0 25px 0;
}
.billing-info .item {
  display: flex;
  padding: 0 0 20px 0;
}
.billing-info .item nb-icon {
  align-self: center;
  color: #007d40;
  cursor: pointer;
  min-height: 20px;
  min-width: 20px;
}
.billing-info .item .double {
  justify-self: end;
}
.billing-info .item .info-row-text {
  padding: 0 0 0 6px;
  word-wrap: anywhere;
}
.billing-info .item .info-row-text p {
  margin: 0;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
}
.billing-info .item .info-row-text p:first-child {
  font-size: 12px;
  line-height: 16px;
  color: #007d40;
  padding: 0 0 5px 0;
}
.billing-info .item .info-row-text p:nth-child(2) {
  font-size: 15px;
  line-height: 24px;
  color: #585858;
}
.billing-info .item .info-row-text span a {
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  font-size: 15px;
  line-height: 24px;
  color: #585858;
}
.double-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
/*# sourceMappingURL=dekra-billing-data.style.css.map */
